import { defineComponent as _defineComponent } from 'vue'
import { PropType } from 'vue';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';


export default /*@__PURE__*/_defineComponent({
  __name: 'CardTag',
  props: {
  message: {
    type: String,
    default: "",
  },
  icon: {
    type: Object as PropType<IconDefinition>,
    default: null,
  },
  iconTitle: {
    type: String,
    default: "",
  },
  size: {
    type: String as PropType<'small' | 'medium'>,
    default: "medium",
  },
  color: {
    type: String as PropType<'primary' | 'success' | 'error'>,
    default: "primary",
  },
},
  emits: ["edit", "back-to-delivery-area", "logout"],
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props;



function getColor() {
  switch (props.color) {
    case 'error':
      return {
        background: '#f6dede',
        color: '#b90b0b'
      }
    case 'success':
      return {
        background: '#DEF6E8',
        color: '#067E36'
      };
    default:
      return {
        background: 'var(--semantic-color-primary-subtle, #F7EDFF',
        color: 'var(--semantic-color-primary-default, #8300C7)'
      }
  }
}

function getSize() {
  switch (props.size) {
    case 'small':
      return '4.5px 7px 4.5px 8px';
    case 'medium':
      return 'var(--semantic-spacing-inset-100, 8px) var(--semantic-spacing-inset-200, 16px)';
  }
}


const __returned__ = { props, getColor, getSize, get FontAwesomeIcon() { return FontAwesomeIcon } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})